import { Box } from '@gemini/core';
import { useAppContext } from '@mfe-presentation/contexts';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';
import { tExists } from '@aviv-estimation-funnel/shells/src/app/helpers/i18n';

const Headline = () => {
    const {
        specificTitle,
        currentStep: { name },
    } = useAppContext();
    const { control } = useFormContext();
    const { t } = useTranslation(NAME_SPACE);

    const isAPrivatePerson = useWatch({ control, name: 'isAPrivatePerson' });

    let title = t(`step_${name}.header.title`);
    // Exception for german translation for Profile Page
    if (name === 'profile') {
        title = t(`step_${name}.header.title.${isAPrivatePerson ? 'individual' : 'professional'}`);
    }
    if (specificTitle) {
        title = t(specificTitle);
    }
    title = tExists(t(title)) ?? '';

    // (i.e.: if it's there, even with a value of null / undefined / "", it will return true)
    const subtitle = tExists(t(`step_${name}.header.subtitle`));

    return (
        <Box
            testId="headline"
            as="header"
            marginTop="spacing.32"
            marginBottom="spacing.16"
            width="100%"
            textAlign={{
                'breakpoint.base': 'left',
                'breakpoint.xs': 'center',
            }}
        >
            {title && (
                <Box
                    as="h1"
                    typography={{
                        'breakpoint.base': 'typography.headline.24.bold',
                        'breakpoint.xs': 'typography.headline.28.bold',
                    }}
                    aria-live="assertive"
                >
                    {title}
                </Box>
            )}
            {subtitle ? (
                <Box
                    as="p"
                    typography="typography.body.14.regular"
                    testId="sub-headline"
                    whiteSpace="pre-line"
                >
                    {/* eslint-disable-next-line react/no-danger */}
                    <div dangerouslySetInnerHTML={{ __html: subtitle }} />
                </Box>
            ) : null}
        </Box>
    );
};

export default Headline;
